import ImmunizationVaricellaView from "./ImmunizationVaricellaView";

export default ImmunizationVaricellaView;
